import moment from 'moment';

export const printInfo = info => {
    if (typeof info === 'undefined' || info === null || info.length === 0) {
      return '-';
    } else {
      return info;
    }
  };

  export const getFullDateTimeWithSeconds = (date) => {
    if (date == null) {
      return "-";
    } else {
      //console.log(date);
      const dt = Date.parse(date);
      if (isNaN(dt)) return "-";
      else return moment(dt).local().format("DD/MM/YYYY HH:mm:ss");
    }
  };